import { Box, Typography } from '@mui/material';

import BlofinLiveOrderPanel from './BlofinLiveOrderPanel';

export default function BlofinManualOrderPage() {
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1100, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>Ordres BloFin</Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Interface LIVE uniquement. La préparation d&apos;une intention ne déclenche aucun ordre ;
        la confirmation explicite reste requise avant MARKET.
      </Typography>
      <BlofinLiveOrderPanel />
    </Box>
  );
}
